/**
 * Remove Professional Dialog Component
 * Feature: 004-restore-missing-features
 * Task: T036
 *
 * Confirmation dialog for permanently removing a professional from the organization
 */

import { Loader2, AlertTriangle } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface RemoveProfessionalDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  professionalName: string
  onConfirm: () => void
  isLoading?: boolean
}

export function RemoveProfessionalDialog({
  open,
  onOpenChange,
  professionalName,
  onConfirm,
  isLoading = false,
}: RemoveProfessionalDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Remover Profissional
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Tem certeza que deseja remover <strong>{professionalName}</strong> da organizacao?
            </p>
            <p className="text-sm text-muted-foreground">
              Esta acao e permanente e nao pode ser desfeita. O profissional perdera acesso a todos
              os dados da organizacao imediatamente.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Remover Profissional
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
